import { render, staticRenderFns } from "./educationCurriculumnExcelUpload.vue?vue&type=template&id=f5f85f14"
import script from "./educationCurriculumnExcelUpload.vue?vue&type=script&lang=js"
export * from "./educationCurriculumnExcelUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5f85f14')) {
      api.createRecord('f5f85f14', component.options)
    } else {
      api.reload('f5f85f14', component.options)
    }
    module.hot.accept("./educationCurriculumnExcelUpload.vue?vue&type=template&id=f5f85f14", function () {
      api.rerender('f5f85f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCurriculumnExcelUpload.vue"
export default component.exports